import { I18n } from '@calendly/i18n'
import { CloseIcon } from '@calendly/ui/components/icons'
import { Modal } from '@calendly/ui/components/modal'
import { HeadingText, BodyText } from '@calendly/ui/components/typography'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'

import CalendlyLogo from 'images/logos/calendly-logo-and-wordmark.svg'

import {
  Wizard,
  Header,
  CalendlyLogoImg,
  CloseButton,
  MobileCloseButton,
  Body,
  Illustration,
  TitleContainer,
  ButtonContainer,
  PrimaryButton,
  SecondaryButton
} from './styles'

export const FullPageWithIllustrationModal = ({
  isOpen,
  onClose,
  illustration,
  title,
  subtitle,
  children,
  primaryButton,
  secondaryButton
}) => {
  const isPhone = useDeviceType('isPhone')
  const isSmallPhone = useDeviceType('isSmallPhone')

  return (
    <Modal isOpen={isOpen}>
      <Wizard>
        {!isPhone && (
          <Header>
            <CalendlyLogoImg src={CalendlyLogo} alt={I18n.t('publisher.trial_loss.calendly_logo')} />
            <CloseButton onClick={onClose} aria-label={I18n.t('publisher.action.close')}>
              <CloseIcon size="large" />
            </CloseButton>
          </Header>
        )}
        <Body>
          {isPhone && (
            <MobileCloseButton onClick={onClose} aria-label={I18n.t('publisher.action.close')}>
              <CloseIcon size="large" />
            </MobileCloseButton>
          )}
          {!isSmallPhone && illustration && (
            <Illustration src={illustration} />
          )}
          <TitleContainer>
            <HeadingText level={2}>{title}</HeadingText>
            <BodyText>{subtitle}</BodyText>
          </TitleContainer>
          {children}
        </Body>
        <ButtonContainer>
          {primaryButton && (
            <PrimaryButton {...primaryButton}>
              {primaryButton.label}
            </PrimaryButton>
          )}
          {secondaryButton && (
            <SecondaryButton {...secondaryButton}>
              {secondaryButton.label}
            </SecondaryButton>
          )}
        </ButtonContainer>
      </Wizard>
    </Modal>
  )
}
